import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { SITE, scrollToId, waMenuLink } from "@/data/site";

const LINKS = [
  { id: "chi-siamo", label: "Chi siamo" },
  { id: "menu", label: "Menù" },
  { id: "piatti-del-giorno", label: "Piatti del giorno" },
  { id: "eventi", label: "Catering & Eventi" },
  { id: "galleria", label: "Galleria" },
  { id: "recensioni", label: "Recensioni" },
  { id: "faq", label: "FAQ" },
  { id: "contatti", label: "Contatti" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const go = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 400);
    } else {
      scrollToId(id);
    }
  };

  return (
    <header className="fixed top-0 inset-x-0 z-40 backdrop-blur-xl bg-[#0D0D0D]/95 border-b border-cream/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-2 flex items-center justify-between">
        <button onClick={() => go("top")} data-testid="nav-logo" className="flex items-center" aria-label="SAPORÉ — torna all'inizio">
          <img
            src="/logo-sapore.png"
            alt="SAPORÉ — Gastronomia d'asporto"
            className="w-[170px] md:w-[190px] lg:w-[250px] h-auto"
            style={{ opacity: 1, filter: "none", mixBlendMode: "normal", objectFit: "contain" }}
          />
        </button>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="text-sm font-medium text-cream/75 hover:text-terracotta-light transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={waMenuLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-order-cta"
            className="hidden md:inline-flex items-center gap-2 rounded-full bg-terracotta text-cream px-5 py-2.5 text-sm font-semibold hover:bg-terracotta-dark hover:-translate-y-0.5 transition-all duration-300"
          >
            <Phone size={15} /> Ordina ora
          </a>
          <button
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-toggle"
            className="lg:hidden w-10 h-10 grid place-items-center text-cream"
            aria-label="Apri menù"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <motion.nav
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          transition={{ duration: 0.3 }}
          className="lg:hidden overflow-hidden bg-[#0D0D0D] border-t border-cream/10"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                data-testid={`nav-mobile-link-${l.id}`}
                className="text-left font-serif text-2xl text-cream hover:text-terracotta-light transition-colors"
              >
                {l.label}
              </button>
            ))}
            <a
              href={waMenuLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-mobile-order-cta"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-terracotta text-cream px-5 py-3 text-sm font-semibold"
            >
              <Phone size={15} /> Ordina ora
            </a>
          </div>
        </motion.nav>
      )}
    </header>
  );
}
